/* eslint-disable import/prefer-default-export */
import { schema } from 'normalizr';
import { PointsConfiguration } from '../models/points-configuration';

export const PointsConfigurationSchema = new schema.Entity<PointsConfiguration>(
  'pointsConfigurations',
);
